import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import config from '../../../../config'
import Header from '../../../Header';
import Footer from '../../Footer';
import Google from '../IconBox/Google'
import '../Dashboard';
import { Container, Row, Col, Card, Button, Form, Tab, Nav } from 'react-bootstrap';
import { buyTransactionHistory, getPresaleStatistics, getTotalPurchased } from '../../../../services/apiServices';
import { useSelector } from 'react-redux';
import { ListTable } from './HistoryTable';
import { Success, Warning } from '../../../../utils/errors';
import { BlockchainClaimToken } from '../../../Web3/Connector';
import { Spin } from 'antd';
import Web3ModalProvider from '../Connectwallet/Web3ModalProvider';
// import { useWeb3ModalProvider } from '@web3modal/ethers/react';



const Dashboard = () => {
    const _useWeb3ModalProvider = Web3ModalProvider()

    const loginDetails = useSelector((state) => state.auth.LoginDetails);
    const walletConnnected = useSelector((state) => state.auth.walletConnnected);
    const [WalletAddress, setWalletAddress] = useState(loginDetails?.walletAddress)
    const [TotalPurchasedToken, setTotalPurchasedToken] = useState(0);
    const [BuyTransactionHistroy, setBuyTransactionHistroy] = useState([]);
    const [AvailableClaim, setAvailableClaim] = useState(0);
    const [ClaimTransactionHistroy, setClaimTransactionHistroy] = useState([]);

    const [ClaimedToken, setClaimedToken] = useState(0);
    const [isLogout, setIsLogout] = useState(false);
    const [presaleContract, setpresaleContract] = useState("");
    const [showLoading, setShowLoading] = useState(false)

    useEffect(() => {
        getTokenBuyHistroy()
        userStatatics()
        getPrice()
    }, [])

    const getPrice = async () => {
        const resStatistics = await getPresaleStatistics();
        if (resStatistics.data?.status) {
            setpresaleContract(resStatistics.data.data.PreSaleAddress || "")
        }
    }

    const userStatatics = async () => {

        const res = await getTotalPurchased(WalletAddress);
        if (res.data.status && WalletAddress) {
            setTotalPurchasedToken(res.data?.data?.totalPurchased || 0)
            setAvailableClaim(res.data?.data?.infiAmount || 0)
            setClaimedToken(res.data?.data?.totalClaimedToken || 0)
        }
    }
    const getTokenBuyHistroy = async () => {
        try {

            const resList = await buyTransactionHistory(loginDetails?.id, loginDetails.accessToken);
            if (resList.data.status) {
                let buy = await resList.data?.data.filter(item => item._trxType == 1);
                let claim = await resList.data?.data.filter(item => item._trxType == 2)
                setBuyTransactionHistroy(buy)
                setClaimTransactionHistroy(claim)
            }
        } catch (err) {
            if (err.response?.data?.message == 'jwt expired') {
                setIsLogout(true)
            }
        }
    }

    const tokenClaim = async () => {
        if (parseFloat(AvailableClaim) === 0) {
            Warning('You don\'t have token balance for claim');
            return;
        }
        if (!walletConnnected) {
            Warning('Please connect your registered wallet');
            return;
        }
        setShowLoading(true)
        const res = await BlockchainClaimToken({
            walletAddress: walletConnnected,
            presaleContract: presaleContract,
            walletProvider: _useWeb3ModalProvider
        });
        setShowLoading(false)
        if (res.status) {
            Success("Token successfully claimed, It will take a few minutes to confirm the transaction.");
            userStatatics()
        } else {
            Warning(res.message);
        }
    }

    return (
        <>
            <Header isLogout={isLogout} />
            <Spin spinning={showLoading} >
                <section className="dashboard pt-5 pb-5">
                    <div className="">


                        <Container>

                            <Row className="justify-content-center">
                                <Col lg={12}>
                                    <div className="cardBox totalBox" >
                                        <Row>
                                            <Col lg={4} className='text-center'>
                                                <h4 className='text-uppercase text-blue'><b>Total Purchased</b></h4>
                                                <h4 className='text-primary'>{parseFloat(TotalPurchasedToken || 0).toFixed(6)} INFI</h4>
                                            </Col>
                                            <Col lg={4} className='text-center'>
                                                <h4 className='text-uppercase text-blue'><b>Available Claim</b></h4>
                                                <h4 className='text-primary'>{parseFloat(AvailableClaim || 0).toFixed(6)} INFI&nbsp;
                                                    <Button onClick={() => tokenClaim()} variant="outline-primary font-monospace" className='btn-sm h-auto lh-1'>Claim</Button></h4>
                                            </Col>
                                            <Col lg={4} className='text-center'>
                                                <h4 className='text-uppercase text-blue'><b>Claimed Token</b></h4>
                                                <h4 className='text-primary'>{parseFloat(ClaimedToken || 0).toFixed(6)} INFI</h4>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col lg={12} className='mt-4'>
                                    <Card className='border-top border-none border-dark purchasetab'>
                                        <Tab.Container id="left-tabs-example" defaultActiveKey="purchasehistory">

                                            <Nav variant="pills" className='bg-dark'>
                                                <Nav.Item>
                                                    <Nav.Link className='pt-3' eventKey="purchasehistory">Purchase History</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link className='pt-3' eventKey="tradehistory">Claim History</Nav.Link>
                                                </Nav.Item>
                                            </Nav>

                                            <Tab.Content>
                                                <Tab.Pane eventKey="purchasehistory">
                                                    <Row className='justify-content-center'>
                                                        <Col lg={12} md={12}>
                                                            <div className='py-4 px-4'>
                                                                <h4 className='text-primary'>Purchase History</h4>
                                                                <Card className='border border-dark mt-4 '>
                                                                    <ListTable
                                                                        DataList={BuyTransactionHistroy}
                                                                        type={1}
                                                                    />
                                                                </Card>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="tradehistory">
                                                    <Row className='justify-content-center'>
                                                        <Col lg={12} md={12}>
                                                            <div className='py-4 px-4'>
                                                                <h4 className='text-primary'> Claim History</h4>
                                                                <Card className='border border-dark mt-4 ' id="regardtable">
                                                                    <ListTable
                                                                        DataList={ClaimTransactionHistroy}
                                                                        type={2} className="text-black " 
                                                                    />
                                                                </Card>
                                                            </div>

                                                        </Col>

                                                    </Row>
                                                </Tab.Pane>

                                            </Tab.Content>

                                        </Tab.Container>
                                    </Card>

                                </Col>
                            </Row>
                        </Container>



                    </div>


                </section>
            </Spin>
            <hr className='mb-0' />
            <Footer />
        </>
    )
}

export default Dashboard;
